import React from 'react';

const IconBtnOrder = props =>
  <svg viewBox="0 0 22 22" {...props}>
    <path d="M7.626 17.999l-5.13-5.332l1.59-1.652l3.54 3.678L17.914 4.001l1.59 1.653L7.626 17.999z" />
  </svg>;

export default IconBtnOrder;
